import { Component, input } from '@angular/core';

@Component({
  selector: 'cmi-loading-spinner',
  templateUrl: './loading-spinner.html',
  host: { class: 'inline-flex items-center justify-center' }
})
export class LoadingSpinner {
  public readonly text = input<string>('');
}
